import React from 'react';

import PublicPage from 'components/PublicPage';

import useActions from 'hooks/useActions';
import { login } from 'actions';
import { default as SignInForm } from 'forms/SignIn';

import { SERIES } from 'config/url';
import { useNavigate, useLocation } from 'react-router';

const SignIn = ({navbarProps}) => {
  const dispatchLogin = useActions(login);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || SERIES;
  const onSuccess = () => {
    navigate(from, { replace: true });
  }

  const onSubmit = (values) => {
    dispatchLogin(values, {onSuccess})
  }

  return (
  <PublicPage navbarProps={navbarProps}>
    <div className="container">
      <div className="box my-6 py-6">
      <SignInForm onSubmit={onSubmit}/>
      </div>
    </div>
  </PublicPage>
  )
}

export default SignIn;